import React, { useEffect } from 'react';
import { structuredData } from '../data/seo';

const SEO = ({ 
  title = 'Bombay Home Gallery', 
  description = 'Premium tiles, bathroom and plumbing showroom in Lucknow', 
  keywords = 'tiles lucknow, bathroom fittings lucknow', 
  canonical = '/',
  additionalStructuredData = null 
}) => {
  const siteUrl = 'https://bombayhomegallery.com';
  const fullCanonical = `${siteUrl}${canonical}`;
  const pageTitle = String(title || 'Bombay Home Gallery');
  
  useEffect(() => {
    // Update document title
    document.title = pageTitle;
    
    // Update or create meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    // Primary meta tags
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    updateMeta('title', pageTitle);
    
    // Open Graph
    updateMeta('og:title', pageTitle, true);
    updateMeta('og:description', description, true);
    updateMeta('og:url', fullCanonical, true);
    updateMeta('og:type', 'website', true);
    
    // Twitter
    updateMeta('twitter:title', pageTitle);
    updateMeta('twitter:description', description);
    
    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', fullCanonical);
    
    // Add structured data
    const existingScript = document.querySelector('script[data-seo="local-business"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo', 'local-business');
      script.textContent = JSON.stringify(structuredData.localBusiness);
      document.head.appendChild(script);
    }
    
    // Add additional structured data if provided
    if (additionalStructuredData) {
      const additionalScript = document.querySelector('script[data-seo="additional"]');
      if (additionalScript) {
        additionalScript.textContent = JSON.stringify(additionalStructuredData);
      } else {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo', 'additional');
        script.textContent = JSON.stringify(additionalStructuredData);
        document.head.appendChild(script);
      }
    }
  }, [pageTitle, description, keywords, fullCanonical, additionalStructuredData]);
  
  return null;
};

export default SEO;
